//mimics database table order_statussen
export const OrderStatusType = {
  AUTOMATICALLY_PROCESSED: 1,
  RE_OFFERED: 3,
  DIFFERENT_ORDER_AMOUNT: 10,
  MANUALLY_PROCESSED: 6,
  DUPLICATE_ORDER_OFFER: 4,
  PROCESS_MANUALLY: 7,
  NO_ORDER_LINES: 8,
  FAILED: 2,
  FAILED_OTHER: 9,
  INVALID_DATA_FORMAT: 11,
}
